module.exports = __webpack_public_path__ + "img/03-title-02-mobile.f6ffe26c.png";